import React from 'react';
import { useLocation } from 'react-router-dom';
import { bkbShopUrlFor } from '../config/bkbShop';

/**
 * Ziel der SPA-Route /shop/*. Ein voller Seitenaufruf von /shop kommt hier gar
 * nicht an, den leitet functions/shop/[[path]].ts schon am Rand um. Diese
 * Komponente faengt nur clientseitige Navigationen ab und schickt sie an
 * dieselbe Adresse, die auch der Server waehlen wuerde. Bis Oktober 2026 hing
 * hier die alte "ShopHop · Coming Soon"-Seite.
 */
const ShopRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();
  const target = `${bkbShopUrlFor(pathname, search)}${hash}`;

  React.useEffect(() => {
    // replace statt assign: der Zwischenhalt /shop soll nicht in der Historie
    // stehen, sonst fuehrt "Zurueck" direkt wieder in die Umleitung.
    window.location.replace(target);
  }, [target]);

  return (
    <p className="page-loading">
      <a href={target}>bauklotzbude.de</a>
    </p>
  );
};

export default ShopRedirect;
